module.exports = __webpack_public_path__ + "assets/img/news (51).75f3f96c.png";